import { createSelector } from "@ngrx/store";

import { CommonState } from "../../../state";
import { NetLossLimit } from "../betting-limit.model";

const selectNetLoss = (state: CommonState) => state.netlossLimitConfirmation;
export const selectNetLossConfirmation = createSelector(selectNetLoss, (state: NetLossLimit) => state);

export const selectBetLimitId = createSelector(selectNetLoss, (state: NetLossLimit) => state.limitId);
